import React, { FC, useRef, useState } from 'react'
import styled, { css } from 'styled-components'

import Icon1 from '../assets/icon1.svg'
import Icon2 from '../assets/icon2.svg'
import Icon3 from '../assets/icon3.svg'
import Icon4 from '../assets/icon4.svg'
import Ca1 from '../assets/CardFlip.webp'
import Icon5 from '../assets/Trefle.svg'
import Icon6 from '../assets/Coeur.svg'

const Content = styled.div`
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  text-align: center;
  padding-bottom: 10%;

  @media (max-width: 900px) {
    padding-bottom: 18%;
    padding-right: 10px;
    padding-left: 10px;
  }
`

const Title = styled.p`
  font-size: 8rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin: -1.5%;

  @media (max-width: 900px) {
    font-size: 5rem;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
  }
`

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #ddd;
  font-family: 'PoppinsMedium';
  margin: 2rem 0;

  @media (max-width: 900px) {
    padding-right: 2rem;
    padding-left: 2rem;
  }
`

const IconRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin-bottom: 2rem;
`

const CardRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 5%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  touch-action: pan-x;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  min-width: 0;

  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;

  &::-webkit-scrollbar {
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
  }

  @media (max-width: 900px) {
    padding-bottom: 3%;
    display: block;
  }

  @media (min-width: 900px) {
    scroll-snap-type: none;
  }
`

const CardTrack = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  width: max-content;

  @media (max-width: 900px) {
    justify-content: flex-start;
    gap: 16px;
    padding: 0 0.5rem;
  }
`

const LargeIcon = styled.img`
  width: 250px;
  height: 250px;
  position: absolute;
  z-index: 99;
  left: 0;
  top: 20%;
  transform: rotate(25deg);

  @media (max-width: 1024px) {
    display: none;
  }
`

const LargeIcon2 = styled.img`
  width: 210px;
  height: 210px;
  position: absolute;
  z-index: 99;
  right: 0;
  top: 20%;

  @media (max-width: 1024px) {
    display: none;
  }
`

const Icon = styled.img`
  width: 20px;
  height: 20px;
`

const CardContainer = styled.div`
  perspective: 1000px;
  width: 250px;
  flex: 0 0 250px;
  scroll-snap-align: start;
  min-width: 0;

  /* 👇 FIX SCROLL MOBILE 1 DOIGT */
  touch-action: pan-x;

  @media (max-width: 900px) {
    width: 220px;
    flex: 0 0 220px;
  }
`

const CardInner = styled.div<{ flipped: boolean }>`
  position: relative;
  width: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;

  @media (min-width: 901px) {
    cursor: pointer;
  }

  ${({ flipped }) =>
    flipped &&
    css`
      transform: rotateY(180deg);
    `}
`

const CardFront = styled.div`
  backface-visibility: hidden;
  border-radius: 16px;

  img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 16px;
    pointer-events: none;
    user-select: none;
  }
`

const CardBack = styled.div`
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
  transform: rotateY(180deg);
  background: url(${Ca1}) center/cover no-repeat;
  border-radius: 16px;

  display: flex;
  align-items: center;
  justify-content: center;
`

const BackContent = styled.div`
  background: linear-gradient(94.5deg, #200d0d 0.98%, #120404 89.97%);
  width: calc(100% - 50px);
  height: calc(100% - 85px);
  border-radius: 8px;
  padding: 1rem;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    width: calc(100% - 65px);
    height: calc(100% - 78px);
  }
`

const BackTitle = styled.p`
  font-size: 2rem;
  font-family: 'MongoGrotesqueLight';
  color: #fff;
  margin-bottom: 0.5rem;
`

const BackText = styled.p`
  font-size: 0.8rem;
  font-family: 'PoppinsMedium';
  color: #ddd;
  text-align: center;
  line-height: 1.4;
`

const PrimaryButton = styled.button`
  background: #ffe6da;
  border: 1px solid #333;
  border-radius: 20px;
  text-decoration: none;
  padding: 0.5rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  color: black;
  transition: background-color 0.2s, color 0.2s;
  margin-top: 2rem;

  &:hover {
    background: black;
    color: white;
    border-color: white;
    transition: background 0.5s ease;
  }
`

// -----------------------------

interface CardData {
  id: number
  front: string
  title: string
  description: string
}

const TAP_SLOP = 10

const FlipItem: FC<{ card: CardData }> = ({ card }) => {
  const [flipped, setFlipped] = useState(false)
  const startX = useRef(0)
  const startY = useRef(0)
  const dragged = useRef(false)

  const onPointerDown: React.PointerEventHandler<HTMLDivElement> = (e) => {
    if (e.pointerType !== 'mouse') return
    startX.current = e.clientX
    startY.current = e.clientY
    dragged.current = false
  }

  const onPointerMove: React.PointerEventHandler<HTMLDivElement> = (e) => {
    if (e.pointerType !== 'mouse') return

    if (
      Math.abs(e.clientX - startX.current) > TAP_SLOP ||
      Math.abs(e.clientY - startY.current) > TAP_SLOP
    ) {
      dragged.current = true
    }
  }

  const onPointerUp: React.PointerEventHandler<HTMLDivElement> = (e) => {
    if (e.pointerType !== 'mouse') return
    if (!dragged.current) setFlipped((f) => !f)
  }

  const onClick: React.MouseEventHandler<HTMLDivElement> = () => {
    setFlipped((f) => !f)
  }

  return (
    <CardContainer
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onClick={onClick}
    >
      <CardInner flipped={flipped}>
        <CardFront>
          <img src={card.front} alt={`Card ${card.id}`} />
        </CardFront>

        <CardBack>
          <BackContent>
            <BackTitle>{card.title}</BackTitle>
            <BackText>{card.description}</BackText>
          </BackContent>
        </CardBack>
      </CardInner>
    </CardContainer>
  )
}

// -----------------------------

const FlipCard: FC = () => {
  const cards: CardData[] = [
    {
      id: 1,
      front: Ca1,
      title: 'Tirage Rapide',
      description:
        'Participez à un tirage au sort express et tentez de gagner des offres spéciales en quelques clics.',
    },
    {
      id: 2,
      front: Ca1,
      title: 'Bonus Exclusif',
      description:
        'Débloquez des récompenses exclusives réservées aux membres et profitez d’avantages uniques.',
    },
    {
      id: 3,
      front: Ca1,
      title: 'Accès VIP',
      description:
        'Gagnez un accès VIP à nos événements et promotions privées.',
    },
  ]

  return (
    <Content>
      <LargeIcon src={Icon5} alt="Trefle" />
      <LargeIcon2 src={Icon6} alt="Coeur" />

      <IconRow>
        <Icon src={Icon2} alt="Icon 2" />
        <Icon src={Icon3} alt="Icon 3" />
        <Icon src={Icon1} alt="Icon 1" />
        <Icon src={Icon4} alt="Icon 4" />
      </IconRow>

      <Title>
        AVEC LE MULTISHOP <br /> EXPLOREZ, GAGNEZ, REPÉTEZ
      </Title>

      <Subtitle>
        En vous inscrivant gratuitement, vous accéderez à des tirages au <br />
        sort réguliers et à des expériences exclusives.
      </Subtitle>

      <CardRow data-allow-scroll>
        <CardTrack>
          {cards.map((c) => (
            <FlipItem key={c.id} card={c} />
          ))}
        </CardTrack>
      </CardRow>

      <PrimaryButton
        onClick={() =>
          window.open('https://jokershop.partouche.com', '_blank', 'noopener')
        }
      >
        Multishop
      </PrimaryButton>
    </Content>
  )
}

export default FlipCard
